import { ReactNode } from 'react';
import styled from 'styled-components';

import { SpacingTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

export interface IFlexRow {
	children?: ReactNode;
	gap?: SpacingTypes;
}

export default styled.div<IFlexRow>`
	display: flex;
	flex-flow: row;
	gap: ${({ gap }) => !!gap && theme.spacing[gap]};
`;
